import { PlayerItemModel, PlaylistItem } from "./player-item.model";

export interface GroupItemModel {
  progress?: number;
  videos?: PlayerItemModel[];
  name: string;
  totaltime: any;
  completed?: boolean;
}


export class GroupItem {
  progress?: number;
  videos?: PlayerItemModel[];
  name: string;
  totaltime: any;
  completed: boolean;


  constructor(groupItem: GroupItemModel) {
    this.videos = groupItem.videos;
    this.name = groupItem.name;
    this.totaltime = groupItem.totaltime;

    const hasUnfinishedVideo = this.videos.some(video => !video.finished)
    if (!hasUnfinishedVideo) {
      this.progress = 100;
      this.completed = true;
    } else {
      this.progress = groupItem.progress;
    }

  }

}



export const GroupItemBuilder = (groupItem: GroupItemModel): GroupItemModel => {
  const videos = groupItem.videos;
  const name = groupItem.name;
  const totaltime = groupItem.totaltime;

  const hasUnfinishedVideo = videos.some(video => !video.finished)
  let progress = 0;
  let completed = false;

  if (!hasUnfinishedVideo) {
    progress = 100;
    completed = true;
  } else {
    progress = groupItem.progress;
  }
  return ({
    videos,
    name,
    totaltime,
    progress,
    completed
  })

}
